import {FaBan, FaBolt, FaChartLine, FaFlask, FaListAlt, FaTrash} from "react-icons/fa";
import {FaPencil, FaSliders} from "react-icons/fa6";
import {MdOutlineRefresh} from "react-icons/md";

export const getActionList = (ioType, isReady) => {
  let actionList;
  if (isReady) {
    if (ioType === "output") {
      actionList = [
        {
          label: "Edit",
          icon: FaPencil,
          perms: ["change_inventorysensors", "change_systeminventory"],
        },
        {label: "Move", icon: FaSliders},
        {label: "Analysis", icon: FaChartLine},
        {label: "Summary", icon: FaListAlt},
        {label: "Test Feed", icon: FaBolt, perms: ["change_inventorysensors"]},
        {label: "Slug Feed", icon: FaFlask, perms: ["change_inventorysensors"]},
        {label: "Reset Limit", icon: FaBan},
        {label: "Delete", icon: FaTrash, perms: ["delete_inventorysensors"]},
      ];
    } else {
      actionList = [
        {
          label: "Edit",
          icon: FaPencil,
          perms: ["change_inventorysensors", "change_systeminventory"],
        },
        {label: "Move", icon: FaSliders},
        {label: "Analysis", icon: FaChartLine},
        {
          label: "Calibrate",
          icon: MdOutlineRefresh,
          condition: "calibrate",
          perms: ["change_inventorysensors"],
        },
        {label: "Summary", icon: FaListAlt},
        {label: "Delete", icon: FaTrash, perms: ["delete_inventorysensors"]},
      ];
    }
  } else {
    actionList = [
      {label: "Analysis", icon: FaChartLine},
      {label: "Summary", icon: FaListAlt},
    ];
  }
  return actionList;
};
